"use client";
import React from "react";
import Image from "next/image";
import EnqueryForm from "@/components/forms/EnqueryForm";
import { FormHeading, SuccessMessageType } from "@/interface/types";

interface AI_accountingProps {
  pageName: string;
}

const AI_accounting: React.FC<AI_accountingProps> = ({ pageName }) => {
  const courseID = pageName === "CPA" || pageName === "CPA/CMA" ? 1 : 2;

  return (
    <div className="relative bg-black">
      <div className="main_container relative z-[1] grid grid-cols-[1fr_1.1fr_420px] items-end max-[900px]:grid-cols-1 max-[900px]:items-start max-[900px]:gap-0 max-[900px]:px-4 max-[900px]:py-7">
        {/* Left column */}
        <div
          className="flex flex-col items-start py-[30px] text-white
         max-[900px]:items-center max-[900px]:p-0 max-[900px]:text-center max-[900px]:order-1"
        >
          <div className="mb-3.5 flex items-center gap-2.5 rounded-[4.057px] border-[1.352px] border-white px-4 py-2 text-base font-bold leading-[1.2] text-white">
            FREE{" "}
            <div className="inline-flex items-center">
              <span className="mr-0.5 inline-block h-2 w-2 rounded-full bg-[#f33]" />
              <span className="text-[#ff3131]">Live</span>
            </div>{" "}
            Webinar
          </div>
          <h2 className="m-0 whitespace-nowrap text-[47px] font-bold leading-[1.15] text-white max-[900px]:whitespace-normal max-[900px]:text-[32px]">
            Build your
            <br />
            <span className="text-[#ffba08]">1st AI-Agent </span>
            in 2 hours
          </h2>
          <p className="mt-2 mb-3.5 text-[22px] font-normal leading-[1.5] text-white [&>strong]:font-bold max-[900px]:mb-5 max-[900px]:text-[18px]">
            by <strong>Varun Jain</strong> &amp; <strong>Uttam Pai</strong>
          </p>

          <div className="flex items-center gap-3 max-[900px]:self-start max-[900px]:justify-start">
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-cma/webinar_badge.webp"
              alt="AI in Accounting 101 – Showcase Badge on LinkedIn"
              width={265}
              height={120}
              className="block w-[265px] h-auto max-[900px]:hidden"
            />
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-cma/101BadgeMob.webp"
              alt="AI in Accounting 101 Badge"
              width={90}
              height={140}
              className="hidden w-[90px] h-auto object-contain max-[900px]:block max-[900px]:absolute max-[900px]:top-[27%] max-[900px]:left-[18px]"
            />
          </div>
        </div>

        {/* Center column - banner */}
        <div className="flex items-end justify-center self-end max-[900px]:order-2">
          <Image
            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-cma/webinarBannerAI_agent.webp"
            alt="Varun Jain and Uttam Pai"
            width={560}
            height={420}
            className="block max-w-[350px] h-auto object-contain object-bottom max-[900px]:mt-5 max-[900px]:-mr-[100px] max-[900px]:max-w-[80%]"
            loading="lazy"
          />
        </div>

        {/* Right column - form */}
        <div
          className="flex items-center justify-end self-center max-[900px]:order-3 max-[900px]:w-full max-[900px]:justify-center"
          id="ai-accounting-webinar-form"
        >
          <div className="relative max-w-[400px] overflow-visible rounded-2xl border border-[#333] bg-black/50 p-4 max-[900px]:w-full max-[900px]:box-border [&_.popoverContent]:w-full [&_.popoverContent]:min-w-0 [&_.popoverContent]:box-border [&_.bengaluruFaqEnquiryForm_.PhoneInputCountry]:bg-[#070c0f] [&_.bengaluruFaqEnquiryForm_.PhoneInputCountry]:border-[#1c2a3a] [&_.bengaluruFaqEnquiryForm_.PhoneInputInput]:rounded-[10px] [&_.bengaluruFaqEnquiryForm_.PhoneInputInput]:border [&_.bengaluruFaqEnquiryForm_.PhoneInputInput]:border-[#333] [&_.bengaluruFaqEnquiryForm_.PhoneInputInput]:bg-black [&_.bengaluruFaqEnquiryForm_.PhoneInputInput::placeholder]:!text-[#adadad]">
            <EnqueryForm
              courseId={courseID}
              pageName={pageName}
              darkBackground={true}
              submitButtonName="Register for Webinar"
              formType="ai accounting 101 webinar banner"
              isAStepperForm
              successMessage={SuccessMessageType.ACCOUNTING}
              formHeading={FormHeading.AI_ACCOUNTING_101_WEBINAR}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AI_accounting;
